import { render } from "./modal-edit-kategori-survei.vue?vue&type=template&id=db8f6f06&scoped=true"
import script from "./modal-edit-kategori-survei.vue?vue&type=script&lang=js"
export * from "./modal-edit-kategori-survei.vue?vue&type=script&lang=js"

import "./modal-edit-kategori-survei.vue?vue&type=style&index=0&id=db8f6f06&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8f6f06"]])

export default __exports__